import client from "./client";

const ContractService = {};

ContractService.getAll = function (data) {
  return client.get(`/contract`, data);
};

ContractService.get = function (contractId) {
  return client.get(`/contract/${contractId}`);
};

ContractService.getByPassport = function (passport) {
  return client.get(`/contract/by-passport/${passport}`);
};

ContractService.getContractSources = function () {
  return client.get(`/contract/sources`);
};

ContractService.create = function (data) {
  return client.post(`/contract`, data);
};

ContractService.createPayment = function (contractId, data) {
  return client.post(`/contract/create-payment/${contractId}`, data);
};

ContractService.changeStatus = function (contractId, status) {
  return client.put(`/contract/change-status/${contractId}/${status}`);
};

ContractService.updateClientDetails = function (contractId, data) {
  return client.put(`/contract/client-details/${contractId}`, data);
};

ContractService.delete = function (contractId, data) {
  return client.put(`/contract/${contractId}`, data);
};

ContractService.forgiveDebt = function (contractId, data) {
  return client.put(`/contract/forgive/${contractId}`, data);
};

ContractService.suspend = function (contractId, data) {
  return client.put(`/contract/suspend/${contractId}`, data);
};

ContractService.deletePayment = function (paymentId) {
  return client.del(`/contract/payment/${paymentId}`);
};

ContractService.applyDiscount = function (contractId, data) {
  return client.post(`/contract/apply-discount/${contractId}`, data);
};
ContractService.deleteDiscount = function (discountId) {
  return client.del(`/contract/discount/${discountId}`);
};

ContractService.sendSms = function (contractId, data) {
  return client.post(`/contract/sms-sender/${contractId}`, data);
};

ContractService.transferContract = function (contractId, data) {
  return client.put(`/contract/transfer/${contractId}`, data);
};

ContractService.changeCategory = function (contractId, data) {
  return client.put(`/contract/change-category/${contractId}`, data);
};

export default ContractService;
